import axios from "axios";
import { http } from "../config/HttpMethod";
import { caseDetailsPayload, copyMyProjectsExistsPayload, copyMyProjectsPayload, GetMyProjectsPayload, mainReportPayload, MyProjects, UpdatePinStatusPayload } from "../models/Myprojects";
import FileSaver, { saveAs } from 'file-saver'
import { ShareWithCustomerModel } from "../models/ShareWithCustomerModel";
import { ESP_ENDPOINTS } from "./calculations/endpoints";
export const getProjects = async (payload: GetMyProjectsPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_ALL_PROJECTS}`, payload);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};

export const createNewCase = async (payload: MyProjects) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.CREATE_NEW_CASE}`, payload);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};

export const updateCaseDetails = async (projectId: string, payload: caseDetailsPayload) => {
    try {
        const response = await http.patch(`${ESP_ENDPOINTS?.UPDATE_CASE_DETAILS}${projectId}`, payload);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getOtherProjects = async (payload: GetMyProjectsPayload) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.GET_OTHER_PROJECTS}`, payload);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getPinProjectsList = async () => {
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_PIN_PROJECTS}`);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
}

export const updatePinStatusProject = async (payload: UpdatePinStatusPayload) => {
    try {
        const response = await http.put(`${ESP_ENDPOINTS?.UPDATE_PIN_STATUS}`, payload);
        return response?.data;
    } catch (error) {
        console.log("error", error);
    }
};

export const getRecentProjectslist = async () => {
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_RECENT_PROJECTS}`);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};

export const copyMyProjects = async (payload: copyMyProjectsPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.COPY_PROJECTS}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const copyMyProjectsExistList = async (payload: copyMyProjectsExistsPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.CHECK_PROJECT_NAME_EXISTS}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const putUpdateProjectStatus = async (id: string, status: number, updateTree: boolean) => {
    try {
        const response = await http.put(`${ESP_ENDPOINTS?.UPDATE_PROJECT_STATUS}${id}`, { status, updateTree });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const postShareWithCustomer = async (params: ShareWithCustomerModel) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.SHARE_WITH_CUSTOMER}`, params);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getSharedcases = async (params: string) => {
    const parmsdata = { parentId: params };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SHARED_CASES}`, { params: parmsdata });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const removeMyProjects = async (payload: any) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.REMOVE_PROJECTS}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
export const getGlobalTemplates = async () => {
    const params = { LegacyID: 1 }
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_GLOBAL_TEMPLATES}`, { params });
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};
export const downloadMainReports = async (payload: any) => {
    try {
        const response = await http.post(`${ESP_ENDPOINTS?.DOWNLOAD_MAIN_REPORT}${payload.reportType}?projectID=${payload.projectId}&unitSystem=${payload.unitSystem}`,
            payload.inputs,
            {
                responseType: 'blob'
            }
        );
        let contentType = '';
        let format = '';
        switch (payload.reportType) {
            case 'CSV':
                contentType = 'text/csv';
                format = 'csv';
                break;
            case 'RTF':
                contentType = 'application/rtf';
                format = 'rtf';
                break;
            case 'IMAGE':
                contentType = 'image/tiff';
                format = 'tiff';
                break;
            default:
                contentType = 'application/pdf';
                format = 'pdf';
                break;
        }
        const blob = new Blob([response.data], { type: contentType });
        const fileName = `${payload.inputs.ProjectName}_ESPReports.${format}`;
        FileSaver.saveAs(blob, fileName);
    } catch (err) {
        console.error('Error downloading the report:', err);
    }
};

export const getProjectStatusCount = async () => {
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_PROJECT_STATUS_COUNT}`);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};

export const getRecentCustomerFeedback = async () => {
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_RECENT_CUSTOMER_FEEDBACK}`);
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
    }
};
